// Node Module Imports
import React from 'react'

import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// Component Imports
import { above, below } from '../../style/design-system'
import ChevronBackground from './ChevronBackground'

// Style Imports

const TextBoxOverImage = ({
  backgroundColor,
  bootstrapClasses,
  childBootstrapClasses,
  children,
  className,
  gatsbyImage,
  gatsbyImageMobile,
  renderContentAboveBox,
  renderContentBelowBox,
  setMobileTextAboveImage,
}) => (
  <div className={`${className} w-100 position-relative`}>
    {renderContentAboveBox && (
      renderContentAboveBox('d-lg-none')
    )}

    {gatsbyImage && gatsbyImageMobile && (
    <>
      <div className={`${setMobileTextAboveImage ? 'd-none' : 'd-block d-lg-none'}`}>
        <GatsbyImage image={gatsbyImageMobile.image} objectPosition={gatsbyImageMobile.objectPosition} className="wrapper-main" alt="" />
      </div>
      <div className="d-none d-lg-block bg-img--abs">
        <GatsbyImage image={gatsbyImage.image} objectPosition={gatsbyImage.objectPosition} objectFit="cover" className="wrapper-main" alt="" />
      </div>
    </>
    )}

    <div className="container">
      <div className="row">
        <div className={`position-relative ${bootstrapClasses}`}>
          {renderContentAboveBox && (
            renderContentAboveBox('d-none d-lg-block')
          )}
          <ChevronBackground
            backgroundColor={backgroundColor}
            bootstrapClasses={childBootstrapClasses}
            className="py-9 py-lg-10 chev-bg"
            direction="north">
            {children}
          </ChevronBackground>
          {renderContentBelowBox && (
            renderContentBelowBox('d-lg-block')
          )}
          {setMobileTextAboveImage && (
            <GatsbyImage image={gatsbyImageMobile.image} objectPosition={gatsbyImageMobile.objectPosition} className="d-lg-none wrapper-below" alt="" />
          )}
        </div>
      </div>
    </div>
  </div>
)

TextBoxOverImage.propTypes = {
  backgroundColor: PropTypes.string,
}

TextBoxOverImage.defaultProps = {
  backgroundColor: 'blue',
}

export default styled(TextBoxOverImage)`
  .container {
    ${below.lg`
      padding: 0;
      width: 100%;
      max-width: 100%;
    `}
  }
  .row {
    ${below.lg`
      margin: 0;
    `}
  }
  [class*="col"] {
    ${below.lg`
      padding-right: 0;
      padding-left: 0;
    `}
  }
  .chev-bg {
    padding-left: 20px;
    padding-right: 20px;
  }
  .wrapper-main {
    height: 100%;
    max-height: 400px;
    ${above.lg`
      max-height: 100%;
    `}
  }
  .wrapper-below {
    height: 400px;
  }
`

// TODO: Prop Types
